import Model from './Model'

export default class Fine extends Model {
    static async all(filters) {
        const params = {has_activity: true, from: filters.from, to: filters.to}
        const {data} = await Http.get(route('api.v1.fines.index'), {params})
        return this.make(data)
    }

    static async create(attributes) {
        const url = route('api.v1.fines.store')
        const {data} = await Http.post(url, this.parseAttributes(attributes))
        return this.make(data)
    }

    async delete() {
        const {data} = await Http.delete(route('api.v1.fines.destroy', this.id))
        return this.fill(data)
    }

    async update(attributes = {}) {
        const url = route('api.v1.fines.update', this.id)
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const {data} = await Http.put(url, payload)
        return this.fill(data)
    }

    getFormAttributes() {
        const attributes = this.except([
            'driver_id', 'driver_name',
            'vehicle_id', 'vehicle_name',
            'package_id', 'package_name',
        ])
        attributes.driver = {value: this.driver_id, label: this.driver_name || 'Not Set'}
        attributes.vehicle = {value: this.vehicle_id, label: this.vehicle_name || 'Not Set'}
        attributes.package = {value: this.package_id, label: this.package_name || ''}

        return attributes
    }

    setAttributes(attributes) {
        super.setAttributes(attributes);
        let tokens = [
            attributes.driver_name,
            attributes.vehicle_name,
            attributes.offense,
            attributes.status,
            attributes.pcn_number
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }
}
